import { StructuredData } from "../types/seo";

export const sanitizeMetaContent = (content: string | undefined): string => {
  if (!content) return "";

  return content
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;")
    .trim();
};

export const formatCanonicalUrl = (
  url: string | undefined,
  baseUrl?: string,
): string => {
  if (!url) return "";

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  const base =
    baseUrl || (typeof window !== "undefined" ? window.location.origin : "");
  const cleanUrl = url.startsWith("/") ? url : `/${url}`;

  return `${base}${cleanUrl}`;
};

export const generateStructuredData = (
  data: StructuredData | StructuredData[],
): string => {
  if (!data) return "";

  try {
    const structuredDataArray = Array.isArray(data) ? data : [data];

    const validData = structuredDataArray.map((item) => {
      const schemaData: StructuredData = {
        ...item,
        "@context": item["@context"] || "https://schema.org",
      };

      return schemaData;
    });

    return JSON.stringify(validData.length === 1 ? validData[0] : validData);
  } catch (error) {
    console.error("Error generating structured data:", error);
    return "";
  }
};

export const truncateDescription = (
  description: string | undefined,
  maxLength: number = 160,
): string => {
  if (!description) return "";

  if (description.length <= maxLength) {
    return description;
  }

  return description.substring(0, maxLength - 3).trim() + "...";
};

export const generateRobotsContent = (
  noindex?: boolean,
  nofollow?: boolean,
  robots?: string,
): string => {
  if (robots) return robots;

  const directives: string[] = [];

  if (noindex) directives.push("noindex");
  else directives.push("index");

  if (nofollow) directives.push("nofollow");
  else directives.push("follow");

  return directives.join(", ");
};
